import './bootstrap';

// Prevent form submit buttons from being clicked more than once
$('#form-submit-once').submit(function(e) {
    if ($(this).hasClass('form-submitted') ) {
        e.preventDefault();
        return;
    }
    $(this).addClass('form-submitted');
    $('.btn-submit-once').prop('disabled', true);
    $('.btn-submit-once').text('Submitting...');
});